import { ChangeDetectionStrategy, Component } from '@angular/core';
import { LinkSection } from '../../types/link';
import { SectionComponent } from '../../components/section/section.component';
import { Section, SectionAttributes } from '../../../app/types/section';


import { EditorIdDirective } from '../../../app/directives/editor-id.directive';
import { TrackClickDirective } from '../../directives/track-click.directive';
import { CardComponent } from '@knorr-bremse-portals/ngx-components/components/card';
import { HtmlComponent } from '@knorr-bremse-portals/ngx-components/components/html';
import { RouterOrExternalLinkDirective } from '@knorr-bremse-portals/ngx-components';
import { FsButtonComponent } from '../../components/fs-button/fs-button.component';

type CopyTextWithLinkListSection = Section<
  {
    numColumns: 12;
    headline: string;
    content: string;
    linkListHeadline: string;
    linkList: LinkSection[];
    url: string;
    label: string;
  } & SectionAttributes,
  [
    'numColumns',
    'headline',
    'content',
    'linkListHeadline',
    'linkList',
    'url',
    'label',
  ],
  'copy-text-with-link-list'
>;

@Component({
    selector: 'app-copy-text-with-link-list',
    styleUrls: ['./copy-text-with-link-list.component.scss'],
    templateUrl: './copy-text-with-link-list.component.html',
    imports: [
        EditorIdDirective,
        TrackClickDirective,
        CardComponent,
        HtmlComponent,
        RouterOrExternalLinkDirective,
        FsButtonComponent,
    ],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CopyTextWithListComponent extends SectionComponent<CopyTextWithLinkListSection> {
}
